document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  const desktopDrawer = document.querySelector('[data-desktop-drawer]');
  const drawerTriggers = document.querySelectorAll('[data-drawer-trigger]');
  const drawerPanels = document.querySelectorAll('[data-drawer-panel]');
  const drawerCloseButtons = document.querySelectorAll('[data-drawer-close]');
  const drawerSubmenuTriggers = document.querySelectorAll('[data-drawer-submenu-trigger]');
  const drawerBackButtons = document.querySelectorAll('[data-drawer-submenu-back]');
  const mobileCloseButtons = document.querySelectorAll('[data-menu-close]');
  const mobilePanels = document.querySelectorAll('[data-mobile-menu-panel]');
  const mobileSubmenuTriggers = document.querySelectorAll('[data-mobile-submenu-trigger]');
  const mobileBackButtons = document.querySelectorAll('[data-mobile-submenu-back]');
  const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const desktopNavLinks = document.querySelectorAll('.site-nav--desktop .site-nav__link');
  const desktopPanelAnimationClasses = ['is-entering-forward', 'is-entering-back'];
  const partnerBathSections = document.querySelectorAll('[data-partner-bath]');
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  let lastDrawerTrigger = null;
  let lastMobileTrigger = null;

  const selectDesktopNavItem = (selectedItem) => {
    desktopNavLinks.forEach((item) => {
      item.classList.toggle('is-selected', item === selectedItem);
    });
  };

  const syncCurrentDesktopNav = () => {
    const currentPath = window.location.pathname.replace(/\/$/, '');
    let currentItem = null;

    desktopNavLinks.forEach((item) => {
      if (!item.matches('a[href]')) return;

      const itemPath = new URL(item.href, window.location.origin).pathname.replace(/\/$/, '');
      if (itemPath === currentPath) currentItem = item;
    });

    selectDesktopNavItem(currentItem);
  };

  const syncDrawerOffset = () => {
    const announcement = document.querySelector('.announcement-bar');
    const offset = announcement ? Math.round(announcement.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--kw-drawer-top', `${offset}px`);
  };

  syncDrawerOffset();
  window.addEventListener('resize', syncDrawerOffset);

  const getFocusable = (container) => Array.from(container.querySelectorAll(focusableSelector))
    .filter((element) => element.offsetParent !== null || element === document.activeElement);

  const focusFirst = (container) => {
    window.requestAnimationFrame(() => {
      const focusable = getFocusable(container);
      focusable[0]?.focus();
    });
  };

  const trapFocus = (event, container) => {
    if (event.key !== 'Tab' || !container) return;

    const focusable = getFocusable(container);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  const closeDesktopDrawer = ({ restoreFocus = true } = {}) => {
    if (!desktopDrawer) return;

    desktopDrawer.classList.remove('is-open');
    desktopDrawer.setAttribute('aria-hidden', 'true');

    drawerPanels.forEach((panel) => {
      panel.hidden = true;
      panel.classList.remove('is-active');
    });

    drawerTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    drawerSubmenuTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });

    syncCurrentDesktopNav();

    if (restoreFocus) lastDrawerTrigger?.focus();
    lastDrawerTrigger = null;
  };

  const showDesktopDrawerPanel = (panelName, direction = 'none') => {
    let activePanel = null;
    const drawerElement = desktopDrawer?.querySelector('.site-drawer-menu__drawer');

    drawerPanels.forEach((panel) => {
      const isTarget = panel.dataset.drawerPanel === panelName;
      panel.classList.remove(...desktopPanelAnimationClasses);
      panel.hidden = !isTarget;
      panel.classList.toggle('is-active', isTarget);
      if (isTarget) {
        activePanel = panel;
        if (direction === 'forward' || direction === 'back') {
          panel.classList.add(direction === 'forward' ? 'is-entering-forward' : 'is-entering-back');
        }
      }
    });

    drawerSubmenuTriggers.forEach((trigger) => {
      const isExpanded = trigger.dataset.drawerSubmenuTrigger === panelName;
      trigger.setAttribute('aria-expanded', String(isExpanded));
    });

    if (direction !== 'none') {
      drawerElement?.scrollTo({ top: 0 });
      window.setTimeout(() => {
        activePanel?.classList.remove(...desktopPanelAnimationClasses);
      }, 260);
    }

    return activePanel;
  };

  const openDesktopDrawer = (panelName, trigger) => {
    if (!desktopDrawer) return;

    closeMobileMenu({ restoreFocus: false });

    const isSameOpen = desktopDrawer.classList.contains('is-open') && trigger.getAttribute('aria-expanded') === 'true';
    if (isSameOpen) {
      closeDesktopDrawer();
      return;
    }

    drawerTriggers.forEach((item) => item.setAttribute('aria-expanded', 'false'));
    trigger.setAttribute('aria-expanded', 'true');
    selectDesktopNavItem(trigger);
    lastDrawerTrigger = trigger;
    const activePanel = showDesktopDrawerPanel(panelName, 'none');
    desktopDrawer.classList.add('is-open');
    desktopDrawer.setAttribute('aria-hidden', 'false');
    focusFirst(activePanel || desktopDrawer);
  };

  const showMobilePanel = (panelName) => {
    mobilePanels.forEach((panel) => {
      const isTarget = panel.dataset.mobileMenuPanel === panelName;
      panel.hidden = !isTarget;
      panel.classList.toggle('is-active', isTarget);
    });

    mobileSubmenuTriggers.forEach((trigger) => {
      const isExpanded = trigger.dataset.mobileSubmenuTrigger === panelName;
      trigger.setAttribute('aria-expanded', String(isExpanded));
    });
  };

  function closeMobileMenu({ restoreFocus = true } = {}) {
    if (!toggle || !menu) return;

    toggle.setAttribute('aria-expanded', 'false');
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('menu-open');
    showMobilePanel('main');

    if (restoreFocus) (lastMobileTrigger || toggle).focus();
    lastMobileTrigger = null;
  }

  const openMobileMenu = () => {
    if (!toggle || !menu) return;

    closeDesktopDrawer({ restoreFocus: false });
    lastMobileTrigger = toggle;
    toggle.setAttribute('aria-expanded', 'true');
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('menu-open');
    showMobilePanel('main');
    focusFirst(menu);
  };

  drawerTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      openDesktopDrawer(trigger.dataset.drawerTrigger, trigger);
    });
  });

  desktopNavLinks.forEach((item) => {
    item.addEventListener('click', () => selectDesktopNavItem(item));
  });

  drawerSubmenuTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const activePanel = showDesktopDrawerPanel(trigger.dataset.drawerSubmenuTrigger, 'forward');
      focusFirst(activePanel || desktopDrawer);
    });
  });

  drawerBackButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const activePanel = showDesktopDrawerPanel(button.dataset.drawerSubmenuBack || 'shop', 'back');
      focusFirst(activePanel || desktopDrawer);
    });
  });

  drawerCloseButtons.forEach((button) => {
    button.addEventListener('click', () => closeDesktopDrawer());
  });

  desktopDrawer?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => closeDesktopDrawer({ restoreFocus: false }));
  });

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeMobileMenu();
      } else {
        openMobileMenu();
      }
    });
  }

  mobileCloseButtons.forEach((button) => {
    button.addEventListener('click', () => closeMobileMenu());
  });

  mobileSubmenuTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      showMobilePanel(trigger.dataset.mobileSubmenuTrigger);
      focusFirst(menu);
    });
  });

  mobileBackButtons.forEach((button) => {
    button.addEventListener('click', () => {
      showMobilePanel('main');
      focusFirst(menu);
    });
  });

  menu?.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => closeMobileMenu({ restoreFocus: false }));
  });

  if ('IntersectionObserver' in window) {
    const partnerBathObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-in-view', entry.isIntersecting);
      });
    }, { threshold: 0.22 });

    partnerBathSections.forEach((section) => partnerBathObserver.observe(section));
  } else {
    partnerBathSections.forEach((section) => section.classList.add('is-in-view'));
  }

  const scrollRevealGroups = [
    { selector: '.kw-category-showcase__intro' },
    { selector: '.kw-category-card', stagger: 70 },
    { selector: '.kw-icon-menu .kw-script' },
    { selector: '.kw-icon-menu__item', stagger: 60, fadeOnly: true },
    { selector: '.kw-gift-wave__media, .kw-gift-wave__content', stagger: 90, fadeOnly: true },
    { selector: '.kw-best-sellers h2' },
    { selector: '.kw-product-card', stagger: 65 },
    { selector: '.kw-collection-panel', stagger: 85 },
    { selector: '.kw-scent-split__copy, .kw-scent-split__media', stagger: 90, fadeOnly: true },
    { selector: '.kw-founder-story__copy, .kw-founder-story__image', stagger: 90 },
    { selector: '.kw-testimonials__heading' },
    { selector: '.kw-testimonial', stagger: 70 },
    { selector: '.kw-wholesale .page-width' },
    { selector: '.kw-instagram-strip__heading' },
    { selector: '.kw-instagram-tile', stagger: 45 }
  ];

  const revealObserver = !prefersReducedMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    })
    : null;

  const setupScrollReveals = (root = document) => {
    scrollRevealGroups.forEach(({ selector, stagger = 0, fadeOnly = false }) => {
      const matchingRoot = root instanceof Element && root.matches(selector) ? [root] : [];
      const elements = [...matchingRoot, ...root.querySelectorAll(selector)];

      elements.forEach((element, index) => {
        if (element.classList.contains('kw-scroll-reveal')) return;

        element.classList.add('kw-scroll-reveal');
        if (fadeOnly) element.classList.add('kw-scroll-reveal--fade');
        element.style.setProperty('--kw-reveal-delay', `${Math.min(index * stagger, 210)}ms`);

        if (revealObserver) {
          revealObserver.observe(element);
        } else {
          element.classList.add('is-visible');
        }
      });
    });
  };

  setupScrollReveals();

  document.addEventListener('shopify:section:load', (event) => {
    setupScrollReveals(event.target);
  });

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const clickedDrawer = target.closest('[data-desktop-drawer]');
    const clickedDrawerTrigger = target.closest('[data-drawer-trigger]');

    if (desktopDrawer?.classList.contains('is-open') && !clickedDrawer && !clickedDrawerTrigger) {
      closeDesktopDrawer({ restoreFocus: false });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      if (desktopDrawer?.classList.contains('is-open')) closeDesktopDrawer();
      if (menu?.classList.contains('is-open')) closeMobileMenu();
      return;
    }

    if (desktopDrawer?.classList.contains('is-open')) {
      trapFocus(event, desktopDrawer);
    } else if (menu?.classList.contains('is-open')) {
      trapFocus(event, menu);
    }
  });

  document.querySelectorAll('[data-collection-carousel]').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const previous = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');

    if (!track || !previous || !next) return;

    const scrollByCard = (direction) => {
      const firstCard = track.querySelector('.collection-card');
      const distance = firstCard ? firstCard.getBoundingClientRect().width + 16 : track.clientWidth * 0.85;
      track.scrollBy({ left: distance * direction, behavior: 'smooth' });
    };

    previous.addEventListener('click', () => scrollByCard(-1));
    next.addEventListener('click', () => scrollByCard(1));
  });

  document.querySelectorAll('[data-collection-sort]').forEach((sortSelect) => {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.assign(url.pathname + url.search + url.hash);
    });
  });

  document.querySelectorAll('.collection-filter').forEach((filter) => {
    const closeButton = filter.querySelector('[data-filter-close]');
    const filterForm = filter.querySelector('.collection-filter__form');

    filterForm?.addEventListener('submit', () => {
      filterForm.querySelectorAll('input[type="number"]').forEach((input) => {
        if (input.value.trim() === '') input.disabled = true;
      });
    });

    closeButton?.addEventListener('click', () => {
      filter.removeAttribute('open');
      filter.querySelector('summary')?.focus();
    });

    document.addEventListener('pointerdown', (event) => {
      if (filter.open && !filter.contains(event.target)) {
        filter.removeAttribute('open');
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && filter.open) {
        filter.removeAttribute('open');
        filter.querySelector('summary')?.focus();
      }
    });
  });

  document.querySelectorAll('[data-collection-grid]').forEach((grid) => {
    const collectionPage = grid.closest('.collection-page');
    const controls = collectionPage?.querySelectorAll('[data-collection-view]') || [];
    let savedView = 'three';

    try {
      savedView = window.localStorage.getItem('kwCollectionView') || 'three';
    } catch (error) {
      savedView = 'three';
    }

    const applyView = (view) => {
      const isCompact = view === 'compact';

      grid.classList.toggle('is-compact', isCompact);
      controls.forEach((item) => {
        const isSelected = item.dataset.collectionView === view;
        item.classList.toggle('is-selected', isSelected);
        item.setAttribute('aria-pressed', String(isSelected));
      });
    };

    applyView(savedView);

    controls.forEach((control) => {
      control.addEventListener('click', () => {
        const view = control.dataset.collectionView || 'three';

        applyView(view);
        try {
          window.localStorage.setItem('kwCollectionView', view);
        } catch (error) {
          // The view still changes when storage is unavailable.
        }
      });
    });
  });

  syncCurrentDesktopNav();
});
